import React from "react";
import { ArrowRight } from "lucide-react";
import BlogPostShare from "./BlogPostShare";
import { BLOG_POSTS } from "../data/blogPosts";

export default function BlogPostSidebar({ currentSlug }) {
  const popularPosts = BLOG_POSTS.filter(
    (post) => post.slug !== currentSlug
  ).slice(0, 7);

  return (
    <div className="flex flex-col">
      {/* Share Section */}
      <div className="hidden sm:block mb-8">
        <BlogPostShare />
      </div>

      {/* Popular Post Card */}
      <div className="bg-white border border-slate-100 rounded-[10px] p-4">
        <h3 className="font-extrabold text-black text-[22px] mb-6">
          Popular Post
        </h3>
        <div className="flex flex-col divide-y divide-slate-100">
          {popularPosts.map((post) => (
            <a
              href={`/blog/${post.slug}`}
              key={post.slug}
              className="flex items-center gap-5 py-6 first:pt-0 last:pb-0"
            >
              <div className="w-[120px] h-[80px] rounded-[10px] overflow-hidden bg-slate-100 shrink-0">
                <img
                  src={post.thumbnail}
                  alt={post.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 flex flex-col justify-center min-w-0">
                <h4 className="font-bold text-black text-[15px] leading-snug line-clamp-2 mb-2">
                  {post.title}
                </h4>
                <div className="flex flex-col text-[12px] text-slate-400 font-medium">
                  <span>{post.date}</span>
                  <span className="mt-0.5">{post.readTime}</span>
                </div>
              </div>
              <span
                aria-label="Read post"
                className="sm:hidden w-11 h-11 rounded-full bg-purple-50 text-[#7209B7] flex items-center justify-center shrink-0 hover:bg-purple-100 transition-colors"
              >
                <ArrowRight className="w-4 h-4" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
